import { connect } from "react-redux";
import PortalAccounts from './PortalAccounts';
import { bindActionCreators } from "redux";
import { loadAccounts } from "Actions/accountActions";

//DESIGN TESTING
function mapStateToProps(state) {
	return {
		accountsInfo: state.accounts
	};
}

function mapDispatchToProps(dispatch) {
	return {
		loadAccounts: bindActionCreators(loadAccounts, dispatch),
	};
}

export default connect(mapStateToProps,mapDispatchToProps)(PortalAccounts);


// WEBPACK FOOTER //
// ./src/components/atomic/pages/PortalAccounts/index.js